const recommendationsTabMessages = {
  title: 'Claim Analysis',
  SubTitle:
    'Leverage tailored suggestions stemming from an in-depth examination of medical and RX claims data. Identify and address abnormalities, monitor shifts in healthcare spending, and unveil opportunities to enhance population health while streamlining costs.',
  emptyData:
    'The chosen group does not have any recommended actions to take at present',
};

export default recommendationsTabMessages;
